/** @file The brush outline as screen-pixel line segments (a 32-gon), drawn through the gizmo layer. */
import type { Vec2 } from '@pose2d/math/types';

const SEGMENTS = 32;

/** Segments of the circle of radius `r` px around (cx, cy); none when r ≤ 0. */
export function brushRing(cx: number, cy: number, r: number): [Vec2, Vec2][] {
  if (!(r > 0)) return [];
  const at = (k: number): Vec2 => [cx + r * Math.cos((2 * Math.PI * k) / SEGMENTS), cy + r * Math.sin((2 * Math.PI * k) / SEGMENTS)];
  return Array.from({ length: SEGMENTS }, (_, k): [Vec2, Vec2] => [at(k), at(k + 1)]);
}
